/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListProductCategoriesRequest
 */
export interface ListProductCategoriesRequest {
    /**
     * 
     * @type {number}
     * @memberof ListProductCategoriesRequest
     */
    cursor?: number;
    /**
     * 
     * @type {number}
     * @memberof ListProductCategoriesRequest
     */
    limit?: number;
}

export function ListProductCategoriesRequestFromJSON(json: any): ListProductCategoriesRequest {
    return ListProductCategoriesRequestFromJSONTyped(json, false);
}

export function ListProductCategoriesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListProductCategoriesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cursor': !exists(json, 'cursor') ? undefined : json['cursor'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function ListProductCategoriesRequestToJSON(value?: ListProductCategoriesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cursor': value.cursor,
        'limit': value.limit,
    };
}


